export function competitorShare(value: number | null, values: (number | null)[]): number {
  const max = values.reduce<number>((peak, item) => (item == null ? peak : Math.max(peak, item)), 0);
  if (value == null || max <= 0) return 0;
  return Math.round((value / max) * 100);
}

/** The stored figure for a chart bar. The bar itself is only a share of the column. */
export function storedCompetitorFigure(
  metric: string,
  domain: string,
  rows: { domain: string; authorityLabel: string; trafficLabel: string; keywordsLabel: string }[],
): string | null {
  const row = rows.find((item) => item.domain === domain);
  if (!row) return null;
  if (metric === "Authority") return row.authorityLabel;
  if (metric === "Traffic") return row.trafficLabel;
  if (metric === "Keywords") return row.keywordsLabel;
  return null;
}
